import React from "react";
import T from "prop-types";
import {
  APPROVAL_STATUSES,
  NOT_APPROVED,
  PENDING,
  APPROVED,
  DENIED,
  APPROVAL_REQUESTED,
  MANAGER_CONSENT_NEEDED
} from "../../constants";

function ApprovalButton({
  btnClass = "btn-default",
  disabled = true,
  func = () => {},
  icon = "bell",
  label
}) {
  return (
    <button
      className={`btn btn-xs btn-block ${btnClass}`}
      disabled={disabled}
      onClick={func}
    >
      <i className={`fa fa-fw fa-${icon}`}>&nbsp;&nbsp;</i>
      {label}
    </button>
  );
}

ApprovalButton.propTypes = {
  disabled: T.bool,
  func: T.func,
  icon: T.string,
  label: T.string,
  btnClass: T.string
};

function Approved({ label = "Approved", type = "success" }) {
  return (
    <span className={`text-${type}`}>
      <i className="fa fa-check" />
      &nbsp;{label}
    </span>
  );
}

Approved.propTypes = {
  label: T.string,
  type: T.string
};

function Denied() {
  return (
    <span className="text-danger">
      <i className="fa fa-close" />
      &nbsp;Denied
    </span>
  );
}

const STATUS_COMPONENTS = {
  [NOT_APPROVED]: props => (
    <ApprovalButton
      btnClass="btn-info"
      disabled={false}
      // eslint-disable-next-line react/prop-types
      func={props.onApprovalRequest}
      icon="check"
      label="Request Approval"
    />
  ),
  [APPROVAL_REQUESTED]: () => <ApprovalButton label="Requested" icon="bell" />,
  [PENDING]: () => <ApprovalButton label="Under Review" icon="bell" />,
  [MANAGER_CONSENT_NEEDED]: () => (
    <Approved label="Mgmt. Consent Needed" type="warning" />
  ),
  [APPROVED]: Approved,
  [DENIED]: Denied
};

export default function VendorApproval(props) {
  return STATUS_COMPONENTS[props.status](props);
}

VendorApproval.propTypes = {
  status: T.oneOf(Object.keys(APPROVAL_STATUSES))
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/VendorApproval.jsx